"use client";

import { usePathname } from "next/navigation";
import { Sidebar } from "./sidebar";
import { GlobalSearch } from "./global-search";

export function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isLogin = pathname === "/login";

  if (isLogin) {
    return <>{children}</>;
  }

  return (
    <>
      <Sidebar />
      <GlobalSearch />
      <main className="md:pl-56 pt-14 md:pt-0 min-h-screen">
        <div className="p-4 md:p-6">{children}</div>
      </main>
    </>
  );
}
